export { default as Button } from './button';
export { default as Selector } from './selector';
export { default as Switch } from './switch';
export { default as Panel } from './tab';



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/tabs/index.tsx